import { withAuthenticationRequired } from '@tom-ui/utils'
import { renderIsoCodeMappingField } from '@host/components/iso-code-mapping-input/IsoCodeMappingField'
import { CreateOrderPage } from '@tom-ui/planning'

export const CreateOrderPageWrapper = withAuthenticationRequired(() => {
  return <CreateOrderPage isoCodeMappingFieldRenderFn={renderIsoCodeMappingField} />
})
